import {LinkingOptions} from '@react-navigation/native';

import {config} from '@/constants/config';
import {EmbedStackParams, Routes} from '@/types/routes';

export const linkingConfig: LinkingOptions<EmbedStackParams> = {
  prefixes: [config.WEB_APP_URL, config.BRANCH_APP_URL, `${config.APP_URL}://`],
  config: {
    screens: {
      [Routes.EmbedPlayer]: {
        path: 'embed/player/:id',
        parse: {
          id: decodeURIComponent,
        },
      },
      [Routes.EmbedArtist]: {
        path: 'embed/artist/:id',
        parse: {
          id: decodeURIComponent,
        },
      },
      [Routes.EmbedPlaylist]: {
        path: 'embed/playlist/:id',
        parse: {
          id: decodeURIComponent,
        },
      },
      [Routes.EmbedPlatform]: {
        path: 'embed/platform/:id',
        parse: {
          id: decodeURIComponent,
        },
      },
      [Routes.EmbedCollection]: {
        path: 'embed/collection/:slug',
        parse: {
          slug: decodeURIComponent,
        },
      },
    },
  },
};
